import restApi from "@plannel/services/utils/rest-api";

const get = (params) => {
  return restApi.get("/api/bftarget", { params });
};

const upsert = data => {
  return restApi.post("/api/bftarget", data);
};

const bfTargetService = {
  get,
  upsert
};


export default bfTargetService;